<template>
    <div>
        <user-menu />
        <div class="wrapper">
            <EnterpriseAdminSidebarMenu :show_menu="true" :show_back_button="false" back_link="enterpriseadminreports"
            />
            <div class="content-wrapper padding-left-165">
                <div class="container-wrapper center">

              <div class="modal-custom" v-show="showOverlay">
                <div class="loader-img-center">
                  <i class="fa fa-spinner fa-spin"></i> Please wait...
                </div>
              </div>
              <div class="my-3"></div>
              <div>
                <div class="col-9 float-left text-left pl-0">
                  <h3 class="d-inline heading text-uppercase">Managers</h3>
                </div>
                <div class="col-3 float-right text-right pr-0" >
                  <div  v-if="users.length > 0" class="margin-t-2 float-right pl-2" @click="shareButtonModal()">
                    <img class="cursor-pointer" src="@/assets/Send_Report_Button.svg" alt="MentorMentee" width="24px" />
                  </div>
                  <div  v-if="users.length > 0" class="margin-t-2 float-right pl-2 mr-2" @click="downloadFunc()">
                    <img class="cursor-pointer" src="@/assets/Download_Report.svg" alt="MentorMentee" width="24px"  />
                  </div>
                  <div v-if="!isReadOnly" class="float-right ml-2">
                    <button type="button" @click="openAddNewUserToLocation()" class="float-right btn btn-sm ma-blue-btn add_manager_btn">New Manager</button>
                  </div>

                  <div class="clear"></div>
                </div>
                <div class="clear"></div>
              </div>
              <div class="border-bottom mt-1 mb-2"></div>








                    <div class="">
                        <flash-message autoHide variant="success"></flash-message>


          <div class="row top-content" v-if="loading == true">
          <div class="col-1 p-0 pl-3 padding-t-10">
            <PuSkeleton :count="1"></PuSkeleton>
          </div>
          <div class="col-2 text-right p-0 pl-3">
            
          </div>
          <div class="col-2 text-right p-0 pl-2">
            <PuSkeleton height="30px" :count="1"></PuSkeleton>
          </div>
          <div class="col-2 text-right p-0 pl-2">
            <PuSkeleton  height="30px" :count="1"></PuSkeleton>
          </div>
          <div class="col-2 text-right p-0 pl-2">
            <PuSkeleton height="30px" :count="1"></PuSkeleton>
          </div>
          <div class="col-2 text-right p-0 pl-2">
            <PuSkeleton height="30px" :count="1"></PuSkeleton>
          </div>
          <div class="col-1 text-right p-0 pl-2 pr-2">
            <PuSkeleton height="30px" :count="1"></PuSkeleton>
          </div>
          </div>





                      <div class="row" v-if="loading == false">
                        <div class="col-3">
                          <div class="pt-3">{{ rows }} Manager(s)</div>
                        </div>

                        <div class="col-9">

                          <div class="search-wrapper col-12">
                              <div class="row col-12 override-padding">
                                  <div class="search_filter_1">
                                      <b-form-select
                                          class="location-custom-select"
                                          name="status"
                                          id="status"
                                          v-model="search_state"
                                          :options="account_state_options"
                                          @change="fetchIUsersListitems">
                                      </b-form-select>
                                  </div>
                                  <div class="search_filter_2">
                                      <b-form-select 
                                          class="location-custom-select" 
                                          v-model="search_group" 
                                          :options="account_groups_options"
                                          @change="fetchIUsersListitems">
                                      </b-form-select>
                                  </div>
                                  <div class="search_filter_3">
                                      <b-form-select
                                          class="location-custom-select"
                                          name="status"
                                          id="status"
                                          v-model="search_status"
                                          :options="status"
                                          @change="fetchIUsersListitems">
                                      </b-form-select>
                                  </div>
                                  <div class="search_filter_4">
                                      <input
                                          type="text"
                                          name="org name"
                                          id="user_fullname"
                                          class="search_org_text"
                                          ref="user_fullname"
                                          v-model="user_fullname"
                                          maxlength="250"
                                          placeholder="Search locations"
                                          @keyup.enter="fetchIUsersListitems">
                                      <div class="search-icon" @click="fetchIUsersListitems">
                                          <i class="fa fa-search search_icons"></i>
                                      </div>
                                  </div>
                                  <div class="search_filter_5">
                                     <button type="button" @click="fetchIUsersListitems()" class="float-left btn btn-sm ma-blue-btn">Filter</button>
                                  </div>
                              </div>
                          </div>


                        </div>

                      </div>

                    </div>
                    <div >
                        <b-card no-body class="manage_locations">
                            <div class="row">
                                
                            </div>

                            <div class="list_locations">
                                <div class="row" v-if="userStatusUpdatedMsg">
                                    <div class="col-12 p-0">
                                        <div class="text-green">{{ userStatusUpdatedMsg }}</div>
                                    </div>
                                </div>
                                <div class="row enterprise-head-row">
                                    <div
                                        class="location_header manage_heading_1"
                                        v-on:click="sortMethod('first_name')"
                                        >
                                        {{ user_type_name }} Name
                                        <i v-if="sortField == 'first_name' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                        <i v-if="sortField == 'first_name' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                    </div>
                                    <div
                                        class="location_header manage_heading_2"
                                        v-on:click="sortMethod('companyName')"
                                        >
                                        Location 
                                        <i v-if="sortField == 'companyName' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                        <i v-if="sortField == 'companyName' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                    </div>
                                    <div
                                        class="location_header manage_heading_8"
                                        v-on:click="sortMethod('userFirstLogin')"
                                        >
                                        First Login 
                                        <i v-if="sortField == 'userFirstLogin' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                        <i v-if="sortField == 'userFirstLogin' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                    </div>
                                    <div
                                        class="location_header manage_heading_9"
                                        v-on:click="sortMethod('userLastLogin')"
                                        >
                                        Last Login
                                        <i v-if="sortField == 'userLastLogin' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                        <i v-if="sortField == 'userLastLogin' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                    </div>
                                    <div
                                        class="location_header manage_heading_4"
                                        v-on:click="sortMethod('userStatus')"
                                        >
                                        Status
                                        <i v-if="sortField == 'userStatus' && publicSortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                        <i v-if="sortField == 'userStatus' && publicSortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                    </div>
                                    <div
                                        class="location_header manage_heading_5"
                                        >
                                        Pathway
                                    </div>
                                    <div
                                        class="location_header manage_heading_6"
                                        >
                                        Current Step
                                    </div>
                                    <div
                                        class="location_header manage_heading_7"
                                        >
                                        Completion
                                    </div>
                                </div>

																<div class="text-center pt-4" v-if="loading == true">
																	<div class="row" v-for="option in 5">
																		<div class="manage_heading_1 pl-0 pr-3"><PuSkeleton :count="1"></PuSkeleton></div>
																		<div class="manage_heading_2 pr-3"><PuSkeleton :count="1"></PuSkeleton></div>
																		<div class="manage_heading_4 pr-3"><PuSkeleton :count="1"></PuSkeleton></div>
																		<div class="manage_heading_5 pr-3"><PuSkeleton :count="1"></PuSkeleton></div>
																		<div class="manage_heading_6 pr-3"><PuSkeleton :count="1"></PuSkeleton></div>
																		<div class="manage_heading_7 text-right padding-l-10"><PuSkeleton :count="1"></PuSkeleton></div>
																		<div class="col-12 p-0">
																			<div class="custom_hr"></div>
																		</div>
																	</div>
																</div>
                                
                                <div v-if="usersCount > 0" class="row_items">
                                    <div class="row_data_border" v-for="(item, index) in users" :key="index">
                                        <div class="location_item_1">
                                            <a @click="goToUserDetail(item.uid, item.accId, index)" class="branding_text_color ea-quick-link font-color-00acee">{{ item.name }}</a>
                                        </div>
                                        <div class="location_item_2">
                                            <a @click="openSidebar(item.accId)" class="branding_text_color ea-quick-link font-color-00acee">{{ item.companyName }}</a>
                                        </div>
                                        <div class="location_item_8">
                                          &nbsp;{{ item.activatedAt }}
                                        </div>
                                        <div class="location_item_9">
                                          &nbsp;{{ item.lastLogin }}
                                        </div>
                                        <div class="location_item_4">
                                          {{ item.userStatus }}
                                        </div>
                                        <div class="location_item_5">
                                          {{ item.pathway }}&nbsp;
                                        </div>
                                        <div class="location_item_6">
                                          {{ item.currentStep }}&nbsp;
                                        </div>
                                        <div class="location_item_7">
                                          {{ item.percent }}
                                        </div>
                                        <div class="clearfix"></div>
                                    </div>
                                </div>
                                <div class="text-red text-center m-4">{{ getNoRecordText(usersCount) }}</div>
                            </div>
														<div class="row" v-if="loading == false">
															<div class="col-3">
																<div class="pt-3">{{ rows }} Manager(s)</div>
															</div>

															<div class="col-9">
															</div>
														</div>
                            <div class="col-12 float-left override-padding pagination-wrapper">
                                <EnterpriseAdminPagination v-if="totalPages" 
                                ref="eadmin_pagination"
                                :currentPage="currentPage"
                                :totalRows="rows"
                                :perPage="perPage"
                                :showPaginatedFunction="showUsersofPaginated"
                                :showPerPageFunction="perPagePaginated"
                                :totalPages="totalPages"
                                :sNo="sno"
                                >
                                </EnterpriseAdminPagination>
                            </div>
                        </b-card>
                    </div>
                    <div class="margin-bottom-10"></div>
                </div>
            </div>
        </div>

        <UserActivateModal 
            :isModalVisible="isUserActivateModal" 
            ref="user_activate_modal"
            page_from="users_menu"
            @close="closeUserActivateModal"
        />
        <UserInactivateModal
            :isModalVisible="isUserInactivateModal" 
            ref="user_inactivate_modal"
            page_from="users_menu"
            @close="closeUserInactivateModal"
        />

        <EnterpriseAdminOverlaySidebar
            :isModalVisible="isModalVisible" 
            @close="closeSidebar"
            ref="location_sidebar" 
            :readOnly="isReadOnly" 
        />

        <AddNewUserToLocation
            :isAddNewUserToLocationModalVisible="isAddNewUserToLocationModalVisible"
            ref="add_new_user_form_to_location"
            :user_type="user_type_name"
            :user_role="user_role"
            @close="closeAddNewUserToLocation"
        />

    <ShareReportModal :isModalVisible="isShareModalVisible" @close="isShareModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading ml-1"><h3>Share Report</h3></div>
      <div slot="body">
        <div v-if="showShareSuccess == true" class="col-12 override-padding success_msg">
          <b>Report shared successfully!</b>
        </div>
        <div class="col-12 override-padding">
          <input v-model="share_email"
                name="share_email"
                placeholder="Enter Email..."
                class="col-lg-12 input-text form-control input-height-35" 
                v-validate="'required|email'"
                data-vv-as="Email address"
                maxlength="255" />
         <div v-show="verrors.has('share_email')" class="validate-warning-msg">{{ verrors.first('share_email') }}</div>
        </div>
        <div class="clear margin-bottom-10"></div>


        <div v-if="showWait == false" class="col-12 override-padding text-align-right">
          <button
              v-on:click="shareButtonSubmit()"
              class="col-3 ma-blue-btn"
              ><b>{{ submit_text }}</b></button>
        </div>
        <div v-if="showWait == true" class="col-12 override-padding text-align-right">
          <button
              
              class="btn-dard-grey col-lg-3"
              ><b>Please wait...</b></button>
        </div>

      </div>
      <div slot="footer" class="col-3 override-padding">

      </div>
    </ShareReportModal>





    </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import axios from 'axios';
import EnterpriseAdminSidebarMenu from '../shared/enterpriseadmin_sidebar_menu.vue';
import EnterpriseAdminOverlaySidebar from './enterpriseadmin_overlay_sidebar.vue';
import EnterpriseAdminPagination from './enterprise_admin_pagination.vue';
import UserActivateModal from './user_activate_modal.vue';
import UserInactivateModal from './user_inactivate_modal.vue';
import AddNewUserToLocation from './add_new_user_to_location.vue';
import ShareReportModal from '../enterpriseadmin/share_email_report_modal.vue';
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});


export default {
    data() {
        return {
            loading: false,
            isModalVisible: false,
            isUserActivateModal: false,
            isUserInactivateModal: false,
            isAddNewUserToLocationModalVisible: false,
            page_title: 'Managers',
            user_type_name: 'Manager',
            user_role: 'ROLE_ADMIN',
            publicSortBy: 'ASC',
            sortField: 'first_name',
            searchParameters: {
              user_type: '',
              sort: {},
            },
            usersCount: 0,
            users: [],
            accountItems: [],
            search_status: '',
            status: [
                {text: 'Status (All)', value: ''},
                {text: 'Active', value: 'active'},
                {text: 'Inactive', value: 'Inactive'}
            ],
            pagination_options: [
                {text: 'Show 25', value: '25'},
                {text: 'Show 50', value: '50'},
                {text: 'Show 100', value: '100'},
                {text: 'Show 150', value: '150'},
                {text: 'Show 200', value: '200'}
            ],
            account_groups_options: [],
            account_state_options: [],
            search_group: '',
            search_state: '',
            user_fullname: '',
            search_status_name: '',
            search_group_name: '',
            statusSelected: [],
            pageOptions: [],
            rows: 0,
            perPage: 25,
            currentPage: 1,
            totalPages: 0,
            sno: 0,
            selectedIndex: '',
            userStatusUpdatedMsg: '',
            isShareModalVisible: false,
            submit_text: 'Submit',
            share_email: '',
            showOverlay: false,
            showWait: false,
            showShareSuccess: false,
            showOverlay: false,
            apiUrl: '',
            isAddNewUserToLocationModalVisible: false,
						userLists: [],
        }
    },
    components: {
        UserMenu,
        EnterpriseAdminSidebarMenu,
        EnterpriseAdminOverlaySidebar,
        EnterpriseAdminPagination,
        UserActivateModal,
        UserInactivateModal,
        AddNewUserToLocation,
        ShareReportModal,
        AddNewUserToLocation,
    },
    computed: {
      isReadOnly(){
        if (this.$store.state.enterprise_type === 'Readonly') {
          return true;
        } else {
          if (this.$store.state.switch_admin_enterprise_isreadonly) {
            return true;
          } else {
            return false;
          }
        }
      }
    },
    methods: {
        shareButtonSubmit: function() {
          this.$validator.validateAll().then((result) => {
            if ((this.verrors.items.length === 0)) {
              this.submit_text = 'Please wait...';
              this.showWait = true;
              this.searchParameters.page = this.currentPage;
              this.searchParameters.perPage = this.perPage;
              this.searchParameters.sort.sortField = this.sortField;
              this.searchParameters.sort.sortBy = this.publicSortBy;
              this.searchParameters.user_type = this.page_title.toLowerCase();
              this.searchParameters.search_status = this.search_status;
              this.searchParameters.search_state = this.search_state;
              this.searchParameters.search_group = this.search_group;
              this.searchParameters.user_fullname = this.user_fullname;
              axios('/enterprise-admin/linked-accounts-users-pdf-share',
              {
                  method: 'POST',
                  data: {
                      'search_parameters': this.searchParameters,
                      'email': this.share_email,
                  }
              })
              .then((resp) => {
                this.share_email = '';
                this.submit_text = 'Submit';
                this.showWait = false;
                this.showShareSuccess = true;
                setTimeout(() => {
                    this.showShareSuccess = false;
                }, 5000)
                //this.isModalVisible = false;
                //this.$emit('close');

               })
              .catch(error => {

              });
            }
          });

        },
        shareButtonModal() {
          this.isShareModalVisible = true;
        },
        downloadFunc: function() {
						this.showOverlay = true;
            this.searchParameters.page = this.currentPage;
            this.searchParameters.perPage = this.perPage;
            this.searchParameters.sort.sortField = this.sortField;
            this.searchParameters.sort.sortBy = this.publicSortBy;
            this.searchParameters.user_type = this.page_title.toLowerCase();
            this.searchParameters.search_status = this.search_status;
            this.searchParameters.search_state = this.search_state;
            this.searchParameters.search_group = this.search_group;
            this.searchParameters.user_fullname = this.user_fullname;
            axios('/enterprise-admin/linked-accounts-users-pdf',
            {
                method: 'POST',
                data: {
                    'search_parameters': this.searchParameters
                }
            })
            .then(response =>  {

              this.pdf_file_name = response.data.pdf_file_name;
              this.showOverlay = false;
              var url = this.apiUrl + '/custom/pdf-view/' + this.pdf_file_name;
   
              //Create XMLHTTP Request.
              var req = new XMLHttpRequest();
              req.open("GET", url, true);
              req.responseType = "blob";
              req.onload = function () {
                  //Convert the Byte Data to BLOB object.
                  var blob = new Blob([req.response], { type: "application/octetstream" });
   
                  //Check the Browser type and download the File.
                  var isIE = false || !!document.documentMode;
                  if (isIE) {
                      window.navigator.msSaveBlob(blob, fileName);
                  } else {
                      var url = window.URL || window.webkitURL;
                      var link = url.createObjectURL(blob);
                      var a = document.createElement("a");
                      a.setAttribute("download", "user_lists.pdf");
                      a.setAttribute("href", link);
                      document.body.appendChild(a);
                      a.click();
                      document.body.removeChild(a);
                  }
              };
              req.send();
              return false;


            })
            .catch(function(error) {
                console.log(error);
            });


        },
        perPagePaginated() {
            this.currentPage = 1;
            this.$refs.eadmin_pagination.currentPageValue = 1;
            this.perPage = this.$refs.eadmin_pagination.perPageValue;
            this.fetchIUsersListitems();
        },
        showUsersofPaginated() {
            this.currentPage = this.$refs.eadmin_pagination.currentPageValue;
            this.fetchIUsersListitems();
        },
        changePageLimit() {
            this.currentPage = 1;
            this.$refs.eadmin_pagination.currentPageValue = 1;
            this.fetchIUsersListitems();
        },
        sortMethod(field) {
            this.sortField = field;
            if (this.publicSortBy == 'ASC') {
                this.publicSortBy = 'DESC';
            } else {
                this.publicSortBy = 'ASC';
            }
            this.fetchIUsersListitems();
        },
        fetchIUsersListitems() {
            this.loading = true;
            this.users = [];
            this.usersCount = 0;
            this.statusSelected = [];
            this.searchParameters.page = this.currentPage;
            this.searchParameters.perPage = this.perPage;
            this.searchParameters.sort.sortField = this.sortField;
            this.searchParameters.sort.sortBy = this.publicSortBy;
            this.searchParameters.user_type = this.page_title.toLowerCase();
            this.searchParameters.search_status = this.search_status;
            this.searchParameters.search_state = this.search_state;
            this.searchParameters.search_group = this.search_group;
            this.searchParameters.user_fullname = this.user_fullname;
            this.searchParameters.search_status_name = this.search_status_name;
            this.searchParameters.search_group_name = this.search_group_name;
            axios('/enterprise-admin/linked-accounts-users',
            {
                method: 'POST',
                data: {
                    'search_parameters': this.searchParameters
                }
            })
            .then(response => {
                this.loading = false;
                this.usersCount = response.data.users.length;
                this.users = response.data.users;
                this.statusSelected = response.data.activeUsers;
                this.currentPage = response.data.page;
                if(this.currentPage > 1) {
                  this.sno = this.perPage * (this.currentPage - 1);
                }
                else {
                  this.sno = 0;
                }
                this.rows = response.data.total_rows;
                this.totalPages = response.data.total_pages;
								this.userLists = response.data.userLists;
                this.clearFlashMessage();
            })
            .catch(() => {
            });
        },
        getEnterpriseStateLists() {
          axios('/enterprise-admin/statelists',
          {
              method: 'GET',
          })
          .then(response => {
              var groupsCount = response.data.state.length;
              this.account_state_options.push({ text:'State (All)', value: '' });
              for (var m = 0; m < groupsCount; m++) {
                  this.account_state_options.push({ 
                      text: response.data.state[m].text, 
                      value: response.data.state[m].value 
                  });
              }
          })
          .catch(() => {
          });
        },
        getEnterpriseGroups() {
                axios('/enterprise-admin/groups/' + this.$store.state.user_accountid,
                {
                    method: 'GET',
                })
                .then(response => {
                    var groupsCount = response.data.groups.length;
                    this.account_groups_options.push({ text:'Group (All)', value: '' });
                    for (var m = 0; m < groupsCount; m++) {
                        this.account_groups_options.push({ 
                            text: response.data.groups[m].text, 
                            value: response.data.groups[m].value 
                        });
                    }
                })
                .catch(() => {
                });
        },
        getNoRecordText(count) {
            if (this.loading) {
                return '';
            } else {
                if (count == 0) {
                    return 'No ' + this.page_title + ' Found';
                }
            }
        },
        showText(val) {
            for (var i = 0; i < this.account_groups_options.length; i++) {
                if (this.account_groups_options[i].value != "" && this.account_groups_options[i].value === val){
                    this.selectedText = this.account_groups_options[i].text;
                    return this.selectedText.charAt(0).toUpperCase() + this.selectedText.slice(1);
                }
            }
            return '';
        },
        closeUserActivateModal() {
            this.isUserActivateModal = false;
            this.$refs['user_status_'+this.selectedIndex][0].checked = false;
        },
        closeUserInactivateModal() {
            this.isUserInactivateModal = false;
            this.$refs['user_status_'+this.selectedIndex][0].checked = true;
        },
        setUserActive(item, index, event) {
            var user = {
                first_name: item.first_name,
                last_name: item.last_name,
                id: item.uid,
                accountId: item.accId,
            }
            this.selectedIndex = index;
            if (event.target.checked) {
                this.isUserActivateModal = true;
                this.$refs.user_activate_modal.setUserInfo(user);
            } else {
                this.isUserInactivateModal = true;
                this.$refs.user_inactivate_modal.setUserInfo(user);
            }
        },
        capitalizeFirstLetter(fname, lname) {
            var userFullName = '';
            if (fname) {
                userFullName += fname.charAt(0).toUpperCase() + fname.slice(1) + ' ';
            } 
            if (lname) {
                userFullName += lname.charAt(0).toUpperCase() + lname.slice(1);
            }
            return userFullName;
        },
        openSidebar(accountId) {
            this.isModalVisible = true;
            this.$refs.location_sidebar.getLocationDetail(accountId);
        },
        closeSidebar() {
            this.isModalVisible = false;
            this.$refs.location_sidebar.selectedComponent = 'OverviewTab';
        },
        goToUserDetail(userId, accountId, index) {
            if(this.currentPage > 1) {
                index = parseInt(index + ((this.currentPage - 1) * 25));
            }
            this.isModalVisible = true;
            this.$refs.location_sidebar.editUserDetail(userId, accountId, 'true', index, this.userLists);
        },
        checkUserStatus(uid, status) {
            return (status == 'Active') ? 'checked' : '';
        },
        openAddNewUserToLocation() {
            this.isAddNewUserToLocationModalVisible = true;
            this.$refs.add_new_user_form_to_location.getLocations();
        },
        closeAddNewUserToLocation() {
            this.isAddNewUserToLocationModalVisible = false;
            this.fetchIUsersListitems();
        },
        clearFlashMessage() {
            setTimeout(() => {
                this.userStatusUpdatedMsg = '';
            }, 2000);
        }
    },
    created() {
      this.loading = true;
      this.apiUrl = process.env.API_ENDPOINT;
      this.fetchIUsersListitems();
      this.getEnterpriseGroups();
      this.getEnterpriseStateLists();
    }
}
</script>
<style scoped>
.manage_locations { padding: 0rem; background-color: #FFF !important; }
.list_locations { padding: 0 1rem; margin: 1rem 0; }
.location_header { float: left; font-weight: 900; margin-top: 15px; }
.manage_heading_1 { width: 18%; cursor: pointer; padding-left: 10px; }
.manage_heading_2 { width: 17%; cursor: pointer; }
.manage_heading_4 { width: 10%; cursor: pointer; }
.manage_heading_5 { width: 13%; }
.manage_heading_6 { width: 12%; }
.manage_heading_7 { width: 10%; text-align: right; }
.manage_heading_8 { width: 10%; cursor: pointer; }
.manage_heading_9 { width: 10%; cursor: pointer; }
.location_item_1 { width: 18%; float: left;  padding-left: 10px; }
.location_item_2 { width: 17%; float: left; }
.location_item_4 { width: 10%; float: left; }
.location_item_5 { width: 13%; float: left; }
.location_item_6 { width: 12%; float: left; }
.location_item_7 { width: 10%; float: left; text-align: right; padding-right: 15px; }
.location_item_8 { width: 10%; float: left;  }
.location_item_9 { width: 10%; float: left;  }
.row_items { margin-right: -15px; margin-left: -15px; font-weight: bold; }
.enterprise-head-row { font-weight: bold;  border-bottom: 4px solid #D1D5D5; color: #002f42; padding-bottom: 5px; }
.row_data_border { padding: 5px 0; margin: 10px 0; font-size: 14px;border-bottom: 1px solid #D1D5D5; }
.row_data_border:nth-last-child(1) { border-bottom: 0 none; }
.text-green { color: #28a745 !important; font-weight: 900; }
.text-red { color: #dc3545 !important; font-weight: 900; }
.ea-group-name, .ea-quick-link, .ea-quick-link:hover {
  text-decoration: none !important;
  cursor: pointer;
}
.heading { padding-left: 0px; }
.overview-icons { color: #bfbfbf; font-size: 1rem; }
.print_icons { font-size: 1.5rem;float: right; margin: 1px 0; color: #000 !important; }
.search_icons { font-size: 1.5rem; color: #bfbfbf; }
.location-custom-select { width: 90%; height: 32px; border-radius: 10px; }
.search_org_text { width: 95%;outline: 0; border: 1px solid #ced4da; background-color: #FFF; border-radius: 10px; height: 32px; padding: 0.375rem 1.75rem 0.375rem 0.75rem; }
.license_text { text-decoration: underline; color: #00acee; }
.search_filter_1 { width: 19%; }
.search_filter_2 { width: 19%; }
.search_filter_3 { width: 19%; }
.search_filter_4 { width: 32%; }
.search_filter_5 { width: 11%; }
.ma-blue-btn, .ma-blue-btn:focus, .ma-blue-btn:active, .ma-blue-btn:hover {
  color: #FFF !important; 
  font-weight: 500;
  width: 100%;
  border-radius: 15px;
}
.loading_show { height: auto; }
.container-wrapper .heading {
    font-size: 24px !important;
    font-weight: normal !important;
}
.search-icon {
  position: absolute;
  top: 5px;
  right: 14%;
}
.search-icon i {
  font-size: 20px;
  font-weight: normal;
}
.modal-header .sub-heading h3 {
  color: #002F42;
  font-size: 15px;
  font-weight: 900;
}
.custom_heading_hr,
.custom_hr {
    width: 100%;
    margin: 5px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.success_msg {
  color: #68C47E; text-align: center; margin-bottom: 15px;
}
.add_manager_btn, .add_manager_btn:hover, .add_manager_btn:active, .add_manager_btn:focus {
  width: auto; padding: 5px 25px;
}
.btn-dard-grey {
  border-radius: 15px;  
	padding: 5px 20px;
	border: 0; 
}
</style>



// WEBPACK FOOTER //
// src/components/enterpriseadmin/account_managers_list.vue